/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the mode?`)
};

const es_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es la moda?`)
};

const de_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Modus?`)
};

const nl_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de modus?`)
};

const fr_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que le mode ?`)
};

const it_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è la moda?`)
};

const pt_br2_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a moda?`)
};

const pt_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a moda?`)
};

const ja_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最頻値とは何ですか?`)
};

const zh_st_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是众数？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_faq_q2", locale)
	if (locale === "en") return en_st_faq_q2(inputs)
	if (locale === "es") return es_st_faq_q2(inputs)
	if (locale === "de") return de_st_faq_q2(inputs)
	if (locale === "nl") return nl_st_faq_q2(inputs)
	if (locale === "fr") return fr_st_faq_q2(inputs)
	if (locale === "it") return it_st_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_st_faq_q2(inputs)
	if (locale === "pt") return pt_st_faq_q2(inputs)
	if (locale === "ja") return ja_st_faq_q2(inputs)
	return zh_st_faq_q2(inputs)
};